import { FC, useCallback, useEffect, useRef } from "react"
import { SlideNavigationWrapperItem } from "./styles"
import { IThemeSlideColor } from "shared/reducers/ThemeSlideColorSlice";
import { useRouteMatch } from "react-router-dom";
import { AppTester } from "supporting";
import { LinkTo } from "../../constants/linkTo";
import {useToastsTheme} from "../../../core/hooks/useToastTheme";

export const SlideWithHover: FC<{
    onClick: () => void,
    active: boolean,
    activeIndexKey?: string;
    isLoading?: boolean;
    whiteTheme?: any;
    autoWidth?: boolean;
    autoFlex?: boolean;
    padding?: number;
    whiteSpace?: boolean;
    disableTab?: boolean;
    isTitle?: boolean;
    overflowX?: boolean;
    capitalize?: boolean;
    blueSelect?: boolean;
    item: any;
    onSetActiveTab?: (val: string | null) => void;
    onSetSizes?: (val: any) => void;
    dataName?: string;
    dataTitle?: string;
    isDesigner?: boolean;
    isEmptyProjects?: boolean;
    importantItemColor?: IThemeSlideColor;
    activeTabRef?: any;
    noLeftPadding?: boolean;
    smallTab?: boolean;
    tabKey?: any;
    customGap?: number | string;
    competitionMobileUnderline?: boolean;
    showActiveTabUnderline?: boolean;
    forceMobile?: boolean;
    activeUnderlineColor?: string;
}> = ({
    onClick,
    active,
    activeIndexKey,
    whiteTheme,
    blueSelect,
    padding,
    whiteSpace,
    disableTab,
    isTitle,
    item,
    onSetSizes,
    onSetActiveTab,
    dataName,
    dataTitle,
    isDesigner,
    isEmptyProjects,
    importantItemColor,
    activeTabRef,
    noLeftPadding,
    smallTab,
    tabKey,
    customGap,
    competitionMobileUnderline,
    showActiveTabUnderline = false,
    forceMobile,
    activeUnderlineColor,
}) => {
    const divRef = useRef<any>(null)
    const isTeamOrCoursePage = !!useRouteMatch(['/teams', '/courses']);
    const isManyExportPage = !!useRouteMatch(LinkTo.manyExport);
    const isCGRAVE = AppTester.isCGRAVE();
    const { darkTheme } = useToastsTheme();
    const isCompetitionRoute = !!useRouteMatch(LinkTo.competition);

    const handleEnter = () => {
        onSetActiveTab && onSetActiveTab(dataName || '')
    };

    const handleLeave = () => {
        onSetActiveTab && onSetActiveTab(null)
    };

    const onItemLoad = useCallback(() => {
        onSetSizes && onSetSizes({
            idx: tabKey, 
            width: divRef?.current?.clientWidth || 0,
            item: tabKey,
        })
    }, [tabKey, activeIndexKey, onSetSizes, divRef.current])


    useEffect(() => {
        if (!divRef.current) return;
        const resizeObserver = new ResizeObserver(() => {
            onItemLoad()
        });
        resizeObserver.observe(divRef.current);
        return () => resizeObserver.disconnect();
    }, [tabKey, onItemLoad]);

    return (
        <SlideNavigationWrapperItem
            ref={(node: HTMLElement | null) => {
                divRef.current = node
                if (active) {
                    activeTabRef.current = node
                }
            }}
            className={"white_theme_project_underline"}
            onClick={onClick}
            active={active}
            white_theme={whiteTheme}
            padding={padding}
            whiteSpace={whiteSpace}
            disableTab={disableTab || isEmptyProjects}
            isTitle={isTitle}
            blueSelect={blueSelect}
            isDesigner={isDesigner}
            isExport={isManyExportPage}
            {...importantItemColor}
            data-title={dataTitle}
            onMouseEnter={handleEnter}
            onMouseLeave={handleLeave}
            isTeamOrCoursePage={isTeamOrCoursePage}
            isCGRAVE={isCGRAVE}
            isGreyColorText={!darkTheme && isCompetitionRoute}
            noLeftPadding={noLeftPadding}
            smallTab={smallTab}
            customGap={customGap}
            $competitionMobileUnderline={competitionMobileUnderline}
            $showActiveTabUnderline={showActiveTabUnderline}
            $forceMobile={forceMobile}
            activeUnderlineColor={activeUnderlineColor}
        >
            {item}
        </SlideNavigationWrapperItem>
    )
}import { FC, useCallback, useEffect, useRef } from "react"
import { SlideNavigationWrapperItem } from "./styles"
import { IThemeSlideColor } from "shared/reducers/ThemeSlideColorSlice";
import { useRouteMatch } from "react-router-dom";
import { AppTester } from "supporting";
import { LinkTo } from "../../constants/linkTo";
import {useToastsTheme} from "../../../core/hooks/useToastTheme";

export const SlideWithHover: FC<{
    onClick: () => void,
    active: boolean,
    activeIndexKey?: string;
    isLoading?: boolean;
    whiteTheme?: any;
    autoWidth?: boolean;
    autoFlex?: boolean;
    padding?: number;
    whiteSpace?: boolean;
    disableTab?: boolean;
    isTitle?: boolean;
    overflowX?: boolean;
    capitalize?: boolean;
    blueSelect?: boolean;
    item: any;
    onSetActiveTab?: (val: string | null) => void;
    onSetSizes?: (val: any) => void;
    dataName?: string;
    dataTitle?: string;
    isDesigner?: boolean;
    isEmptyProjects?: boolean;
    importantItemColor?: IThemeSlideColor;
    activeTabRef?: any;
    noLeftPadding?: boolean;
    smallTab?: boolean;
    tabKey?: any;
    customGap?: number | string;
    competitionMobileUnderline?: boolean;
    showActiveTabUnderline?: boolean;
    forceMobile?: boolean;
    activeUnderlineColor?: string;
}> = ({
    onClick,
    active,
    activeIndexKey,
    whiteTheme,
    blueSelect,
    padding,
    whiteSpace,
    disableTab,
    isTitle,
    item,
    onSetSizes,
    onSetActiveTab,
    dataName,
    dataTitle,
    isDesigner,
    isEmptyProjects,
    importantItemColor,
    activeTabRef,
    noLeftPadding,
    smallTab,
    tabKey,
    customGap,
    competitionMobileUnderline,
    showActiveTabUnderline = false,
    forceMobile,
    activeUnderlineColor,
}) => {
    const divRef = useRef<any>(null)
    const isTeamOrCoursePage = !!useRouteMatch(['/teams', '/courses']);
    const isManyExportPage = !!useRouteMatch(LinkTo.manyExport);
    const isCGRAVE = AppTester.isCGRAVE();
    const { darkTheme } = useToastsTheme();
    const isCompetitionRoute = !!useRouteMatch(LinkTo.competition);

    const handleEnter = () => {
        onSetActiveTab && onSetActiveTab(dataName || '')
    };

    const handleLeave = () => {
        onSetActiveTab && onSetActiveTab(null)
    };

    const onItemLoad = useCallback(() => {
        onSetSizes && onSetSizes({
            idx: tabKey, 
            width: divRef?.current?.clientWidth || 0,
            item: tabKey,
        })
    }, [tabKey, activeIndexKey, onSetSizes, divRef.current])


    useEffect(() => {
        if (!divRef.current) return;
        const resizeObserver = new ResizeObserver(() => {
            onItemLoad()
        });
        resizeObserver.observe(divRef.current);
        return () => resizeObserver.disconnect();
    }, [tabKey, onItemLoad]);

    return (
        <SlideNavigationWrapperItem
            ref={(node: HTMLElement | null) => {
                divRef.current = node
                if (active) {
                    activeTabRef.current = node
                }
            }}
            className={"white_theme_project_underline"}
            onClick={onClick}
            active={active}
            white_theme={whiteTheme}
            padding={padding}
            whiteSpace={whiteSpace}
            disableTab={disableTab || isEmptyProjects}
            isTitle={isTitle}
            blueSelect={blueSelect}
            isDesigner={isDesigner}
            isExport={isManyExportPage}
            {...importantItemColor}
            data-title={dataTitle}
            onMouseEnter={handleEnter}
            onMouseLeave={handleLeave}
            isTeamOrCoursePage={isTeamOrCoursePage}
            isCGRAVE={isCGRAVE}
            isGreyColorText={!darkTheme && isCompetitionRoute}
            noLeftPadding={noLeftPadding}
            smallTab={smallTab}
            customGap={customGap}
            $competitionMobileUnderline={competitionMobileUnderline}
            $showActiveTabUnderline={showActiveTabUnderline}
            $forceMobile={forceMobile}
            activeUnderlineColor={activeUnderlineColor}
        >
            {item}
        </SlideNavigationWrapperItem>
    )
}